<template>
	<custom-popover :style="{left: left + 'px', top: top + 'px' }" style="position: fixed">
		<div class="add-menu-popover">
			<div @click="close()" class="close-menu-button">
				<img class="close-popover" src="@/assets/svg/close.svg">
			</div>
			<select-variable-popover
				:variable-instance="selectedVariable"
				@variable-updated="variable => onVariableUpdated(variable)"
				@close="close"
			/>
		</div>
	</custom-popover>
</template>

<script>
	import EventBus from '@/assets/js/eventBus.js'
	import SelectVariablePopover from '@/components/SelectVariablePopover'
	import VariableHelpers from '@/assets/js/variableHelpers'

	export default {
		name: 'AddMenu',
		props: {
			top: Number,
			left: Number
		},
		data () {
			return {
				showCreatable: false,
				showFormatType: false,
				selectedData: {},
				variableChosen: null,
				formatTypeChosen: '',
				selectedVariable: null
			}
		},
		methods: {
			onVariableUpdated (variable) {
				this.selectedVariable = variable
				EventBus.$emit('addVariableAction', this.selectedVariable)
				this.close()
			},
			formatWasChosen(chosenFormat) {
				console.log(`format was chosen: ${chosenFormat}`)
				if (chosenFormat) {
					this.formatTypeChosen = chosenFormat
				}
			},
	
			showCreateVariable(event, variable) {
				this.menuX = event.clientX
				console.log(this.menuX)
				console.log(window.innerWidth)
				if (window.innerWidth - this.menuX < 500) {
					this.menuX = window.innerWidth - 550
				}
				this.menuY = event.clientY + 15
				this.selectedVariable = variable || null
				// console.log(`selected data: ${JSON.stringify(this.selectedData, null, 2)}`)
				this.showCreatable = true
				// this.textSelected = false
				// console.log("\n\n\nshowing create variable!!!\n\n\n")
			},
			close() {
				this.showCreatable = false
				this.showFormatType = false
				this.textSelected = false
				// this.$nextTick(() => {
					EventBus.$emit('addVariableClosed', this.variableChosen)
				// })
			}
		},
		mounted() {
			// console.log(`parent refs from AddMenu component: ${JSON.stringify(this.parentRefs, null, 2)}`)
			// console.log('show me: ', this.selectedData)
			
		},
		components: {
			SelectVariablePopover
			// AddVariablePopover,
			// AddVariableFormat
		}
	}
</script>

<style lang="less">
	.add-menu {
		width: 200px;
		padding: 10px 0;
		color: #fff;
		background: #3d464a;
		position: fixed;
		display: block;
		top: 0;
		left: 0;
		z-index: 99;

		&:before {
			content: '';
			border-left: 7px solid transparent;
			border-right: 7px solid transparent;
			border-bottom: 7px solid #3d464a;
			position: absolute;
			display: block;
			top: -7px;
			left: 5px;
		}
	}

	.add-menu-popover {
		position: absolute;
		background-color: rgba(61, 70, 74, 0.4);
		top: 0;
		width: 100%;
		height: 100%;
		padding: 85px;
		z-index: 99;
		color: #fff;
	}

	.add-menu-link {
		line-height: 28px;
		padding: 0 20px;

		&:hover {
			color: #8F979C;
			cursor: pointer;
		}
	}

	.close-menu-button {
		position: absolute;
		top: -12px;
		right: -12px;
		z-index: 10;

		&:hover {
			cursor: pointer;
		}

		.close-popover {
			width: 24px;
		}
	}

	.create-popup-body {
		position: absolute;
		display: block;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(61, 70, 74, 0.4);
	}

	.create-popup {
		position: fixed;
		background: #fff;
	}
</style>

